<template>
  <div>
    <choose-component-transform-or-link :items='linksWithIcons' @next='$emit("next")' @select='select' :initial-selection='(initialSelection||{}).name' />
  </div>
</template>
<script>
import ChooseComponentTransformOrLink from '@ui/molecules/ChooseComponentTransformOrLink.vue';
import LinkVariant from '@icons/LinkVariant.vue';
import * as ComponentsDb from '@edit/tree/componentsdb.js';
export default {
  props:{
    component: {
      type: Object,
      required: true
    },
    partutil:{
      type:Object,
      required:true
    },
    transform:{
      type:Object,
      required:true
    },
    initialSelection:{
      type:Object,
      default() {
        return {}
      }
    }
  },
  components: {
    ChooseComponentTransformOrLink
  },
  mounted() {
    if (this.links.length === 1) {
      const link = this.links[0];
      this.$emit("select", {link});
      this.$emit("next");
    }
  },
  data() {
    console.log('have initialSelection', this.initialSelection);
    const links = ComponentsDb.createSlots(this.component, this.partutil, this.transform);
    const linksWithIcons = links.map( (link) => {
      return {icon:LinkVariant,...link,text:link.title,type:link.name}
    });
    return {
      links,
      linksWithIcons
    }
  },
  methods: {
    select(in_type) {
      console.log('LINK', in_type);
      const link = this.links.filter( ({name}) => {
        return in_type === name;
      })[0];
      console.log('got link', link);
      this.$emit("select", {link});
    }
  }
}
</script>

